module.exports = __webpack_public_path__ + "static/media/portfolio6-0.fa1d2578.png";